import { SagaIterator } from '@redux-saga/core'
import { Action } from 'lib/redux/models'
import { all, put, call, takeLatest } from 'redux-saga/effects'
import { CONTENT } from '../actionTypes'
import getMovimientoLayout from 'services/movimientos/getMovimientoLayout'

function* getLayoutContent(action: Action) {
  yield put(CONTENT.request())
  try {
    const data = yield call(getMovimientoLayout, action?.payload)
    if (data) {
      yield put(CONTENT.success(data))
    }
  } catch (error) {
    yield put(CONTENT.failure(error.message))
  } finally {
    yield put(CONTENT.fulfill())
  }
}

export function* movimientoLayoutSagas(): SagaIterator {
  yield all([takeLatest(CONTENT.TRIGGER, getLayoutContent)])
}
